import React from 'react';
import Carousel from './base';
import { SmallPrevArrow, SmallNextArrow } from './arrows';

const defaultSliderSettings = {
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 5, slidesToScroll: 5 } },
    { breakpoint: 768, settings: { slidesToShow: 6, slidesToScroll: 6 } },
    { breakpoint: 412, settings: { slidesToShow: 5, slidesToScroll: 5 } },
    { breakpoint: 360, settings: { slidesToShow: 4, slidesToScroll: 4 } }
  ]
};

export default function SmallCarousel(props) {
  const sliderSettings = {
    ...defaultSliderSettings,
    lazyLoad: false,
    prevArrow: <SmallPrevArrow />,
    nextArrow: <SmallNextArrow />
  };
  return <Carousel {...sliderSettings} {...props} />;
}

export { defaultSliderSettings };
